<template>
  <div>
    <div class="detail" style="position: relative">
      <div class="info">
        <img
          v-if="fom.name == '中国电信'"
          style="width: 60px; height: 60px; border-radius: 50%"
          src="../assets/电信.jpg"
        />
        <img
          v-if="fom.name == '中国联通'"
          style="width: 60px; height: 60px; border-radius: 50%"
          src="../assets/联通.jpg"
        />
        <img
          v-if="fom.name == '中国移动'"
          style="width: 60px; height: 60px; border-radius: 50%"
          src="../assets/移动.jpg"
        />
        <img
          v-if="fom.name == '三网通'"
          style="width: 60px; height: 60px; border-radius: 50%"
          src="../assets/三网通.jpg"
        />
        <img v-if="fom.name == '中国广电'" class="img" src="../assets/g.png" />
        <span class="card" style="width: 100%">
          <div class="name">
            {{ fom.virtualNumber ? fom.virtualNumber : fom.meCardNum }}
          </div>
          <div class="name" @click="pos" style="width: 80%">
            {{ fom.displayName }}
          </div>
        </span>
      </div>
      <!-- <div
        @click="switchs"
        style="
          position: absolute;
          color: #009fff;
          border-bottom-left-radius: 13px;
          border-top-left-radius: 13px;
          top: 30%;
          text-align: center;
          line-height: 26px;
          right: 0px;
          font-size: 16px;
          font-weight: 500;
          width: 80px;
          height: 26px;
          background: white;
          margin-left: 0px;
        "
      >
        切换账号
      </div> -->
      <div class="info" style="margin-top: 20px">
        <div class="detail-list">
          <div v-if="fom.state == -1" class="names">未知</div>
          <div v-if="fom.state == 0" class="names">正常</div>
          <div v-if="fom.state == 1" class="names">单项停机</div>
          <div v-if="fom.state == 2" class="names">停机</div>
          <div v-if="fom.state == 3" class="names">预销号</div>
          <div v-if="fom.state == 4" class="names">销号/拆机</div>
          <div v-if="fom.state == 5" class="names">过户</div>
          <div v-if="fom.state == 6" class="names">休眠</div>
          <div v-if="fom.state == 7" class="names">待激活</div>
          <div v-if="fom.state == 8" class="names">已停用</div>
          <div v-if="fom.state == 9" class="names">库存</div>
          <div v-if="fom.state == 10" class="names">已失效</div>
          <div v-if="fom.state == 11" class="names">违章停机</div>
          <div v-if="fom.state == 12" class="names">挂失</div>
          <div v-if="fom.state == 13" class="names">用户报停</div>
          <div v-if="fom.state == 14" class="names">不存在</div>
          <div v-if="fom.state == 15" class="names">低速</div>
          <div v-if="fom.state == 16" class="names">可测试</div>
          <div class="names">当前状态</div>
        </div>
        <div class="detail-list">
          <div class="name">{{ fom.balance }}</div>
          <div class="name">设备余额</div>
        </div>
        <div class="detail-lists">
          <div class="names">
            <span v-if="fom.officialRealName == 0">已实名</span>
            <span v-if="fom.officialRealName == 1">未实名</span>
            <span v-if="fom.officialRealName == -1">未知</span>
          </div>
          <div class="names">官方实名</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { phoneSimCard } from "../api/cardOperation";
  export default {
    name: "HelloWorld",
    data() {
      return {
        fom: {},
      };
    },
    created() {
      this.phoneSimCard();
    },
    methods: {
      switchs() {
        this.$router.push(`/switch`);
      },
      pos() {
        this.$toast({
          message: this.fom.displayName,
          position: "top",
        });
      },
      phoneSimCard() {
        phoneSimCard().then((res) => {
          if (res.status) {
            this.fom = res.data;
          }
        });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .detail {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: url("../assets/微信图片_20210524132009.png") no-repeat;
    background-size: 100% 100%;
    padding: 10px;
    box-sizing: border-box;
    .info {
      height: 70px;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      .card {
        margin-left: 20px;
        width: 100%;
        height: 100%;
        // background: green;
        text-align: center;
        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 15px;
          text-align: left;
          font-weight: 700;
          color: white;
        }
      }

      .detail-list {
        width: 30%;
        height: 70px;
        margin-left: 3%;
        .names {
          margin-top: 7px;
          font-size: 14px;
          color: white;
        }
        .name {
          margin-top: 8px;
          font-size: 14px;
          color: white;
        }
      }
      .detail-lists {
        width: 30%;
        height: 70px;
        margin-left: 3%;
        .names {
          margin-top: 7px;
          font-size: 14px;
          color: white;
        }
      }
    }
  }
  .active {
    color: #ffd700;
  }
</style>
